// @flow
import AirDatepicker from "air-datepicker";

import { isMobile } from "../../shared/hooks/useResponsiveBreakpoints";
import { localization } from "./constants";

type Options = {|
  onSelect: (selectProps: { date: Date, formattedDate: string }) => void,
|};

// Returns a monkeypatched AirDatepicker instance from the untyped air-datepicker module.
// $FlowFixMe[unclear-type]
export const initializeDatePicker = (element: HTMLInputElement, options?: Options): any => {
  const isMobileScreen = isMobile(window.innerWidth);

  const datePicker = new AirDatepicker(element, {
    locale: localization,
    autoClose: true,
    isMobile: isMobileScreen,
    navTitles: {
      // eslint-disable-next-line i18next/no-literal-string
      days: "MMMM <i>yyyy</i>",
    },
    ...options,
  });

  const onScreenResize = () => {
    datePicker.update({ isMobile: isMobile(window.innerWidth) }, { silent: true });
  };
  window.addEventListener("resize", onScreenResize);

  const originalDestroy = datePicker.destroy;
  datePicker.destroy = () => {
    window.removeEventListener("resize", onScreenResize);
    originalDestroy();
  };

  return datePicker;
};
